import styled from 'styled-components';
import { shade, transparentize } from 'polished';
import { Colors } from '../../../consts';
import { ButtonBaseSkin, buttonBoxShadow } from './ButtonBaseSkin';

var ButtonSecondaryBaseSkin = function ButtonSecondaryBaseSkin(color) {
  return styled(ButtonBaseSkin).withConfig({
    displayName: "ButtonSecondarySkin",
    componentId: "spx7tg-0"
  })(["background-color:transparent;color:", ";box-shadow:", ";", " &:hover:not(:disabled){box-shadow:none;background-color:", ";}"], color, buttonBoxShadow(color), function (_ref) {
    var spinner = _ref.spinner;
    return !spinner && "\n      &:disabled {\n        box-shadow: ".concat(buttonBoxShadow(transparentize(0.84, color)), ";\n        color: ").concat(transparentize(0.6, color), ";\n      }\n  ");
  }, shade(0.76, color));
};

export var ButtonSecondaryGreySkin = ButtonSecondaryBaseSkin(Colors.GREY);
export var ButtonSecondaryRedSkin = ButtonSecondaryBaseSkin(Colors.RED);